import { ICianMortgage } from '../../types/promosPage';
import { IApplicationState } from '../../types/redux';

export const selectMortgage = (state: IApplicationState): ICianMortgage => {
  return state.promosPage.cianMortgage;
};
